import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";
import { useLocation, useNavigate } from 'react-router-dom';

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Company } from "@/views/Settings/Company";
import { Invoice } from "@/views/Settings/Invoice";
import { Website } from "@/views/Settings/Website";
import { Interest } from "@/views/base/user/Interest";
import {authoriseDropBoxWithCode, setTabId} from "@/reducers/Settings";
import { BaseSettings } from "./BaseSettings";
import { Storage } from "./Storage";
import {SETTINGS} from "@/actions/globalConst";
import {PDFTemplates} from "@/views/Settings/PDFTemplates";
import { IntroPanel } from "../base/view/intro";
export function Settings({...props}) {
    const location = useLocation();
    const navigate = useNavigate();
    let selectedTabInit = ((props?.selectedTab) ? props?.selectedTab : 1);
switch(location.hash) {
    case '#company':
        selectedTabInit = 1;
        break;
    case '#base':
        selectedTabInit = 2;
        break;
    case '#invoice':
        selectedTabInit = 3;
        break;
}        
    
    const [selectedTab, setSelectedTab] = useState(selectedTabInit);

const tabs = [
  {tabId: 1, name: 'Bedrijfsgegevens', href: '#company', icon: UserIcon, current: true },
  {tabId: 2, name: 'Basisgeggevens', href: '#base', icon: UserIcon, current: false },
  {tabId: 5, name: 'Website', href: '#website', icon: UserIcon, current: false },
  {tabId: 3, name: 'Facturatie', href: '#invoice', icon: UserIcon, current: false },
  {tabId: 4, name: 'PDF templates', href: '#pdftemplates', icon: UserIcon, current: false },
  //{tabId: 4, name: 'Opslag', href: '#storage', icon: UserIcon, current: false },
]  // More people...
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


    useEffect(() => {
const params = new URLSearchParams(location.search);
const dropboxReturnCode = (params.get("code")); // is the number 123
        
        console.debug( "propssss", props )
        if(dropboxReturnCode && dropboxReturnCode != "" && props?.SettingsReducer?.api_state != SETTINGS.API_PENDING) {

const params = {
};
const options = {
  pathname: location.pathname,
  search: '',
};
navigate(options, { replace: true });


            
            store.dispatch( authoriseDropBoxWithCode(dropboxReturnCode));
            if(location?.hash || location.pathname.endsWith('/storage')) {
                tabs.forEach((item) => {
                    if(((item.href == location.hash) || location.pathname.endsWith('/storage') ) && selectedTab == 0) {
                        setSelectedTab(item.tabId);
                    }
                    }); 
                } else {
                    setSelectedTab(1);
                    
                    
            }
        }

    return () => {

    };
  }, [tabs, location]);



const setTab = (tabId) => {
//    store.dispatch( getUserInterests()).then((value) => {
//        });
    store.dispatch( setTabId({tabId: tabId}) );
    setSelectedTab(tabId);
    
    }
    
   const onSaveHandler = (data) => {
    event.preventDefault();
    event.stopPropagation();


    props.onSaveHandler(data);
      
    return false;

    }
 
      return (
    <>


    <div className="px-4 sm:px-6 lg:px-8">
<IntroPanel txtKey="settings" className="w-full"/>
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.current).name}
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500">
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => setTab(tab.tabId)}
                aria-current={tab.tabId == selectedTab ? 'page' : undefined}
                className={classNames(
                  tab.tabId == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
                )}
              >
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
    
    
    {selectedTab == 1 &&
    <Company {...props} key="Tenant" id="currentTenant" data={props.SettingsReducer}  onSaveHandler={onSaveHandler}/>
    }
    {selectedTab == 2 &&
    <BaseSettings {...props} key="baseSettings" id="baseSettings" data={props.SettingsReducer}  />
    }

    {selectedTab == 5 &&
    <Website {...props} key="Website" id="currentTenantWebsite" data={props.SettingsReducer.settings_website}  onSaveHandler={onSaveHandler}/>
    }

    {selectedTab == 3 &&
    <Invoice {...props} key="invoiceSettings" id="invoiceSettings" data={props.SettingsReducer}  onSaveHandler={onSaveHandler}/>
    }

    {selectedTab == 4 &&
    <PDFTemplates {...props} key="pdfTemplatesSettings" id="pdfTemplatesSettings" data={props.SettingsReducer}  onSaveHandler={onSaveHandler}/>
    }

    
    {selectedTab == 99999 &&
    <Storage {...props} key="storageSettings" id="storageSettings" data={props.SettingsReducer}  onSaveHandler={onSaveHandler}/>
    }
    
    </div>


    </>
    );
  }
